import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// THIS IS THE ENTRY POINT FOR REACT:  YOU CAN TOGGLE BETWEEN ./App-stream.jsx and ./App-ask.jsk  
// the filenames reflect the URL ENDPOINT that the chat calls on the server side: STREAM uses tokens and sinks, ASK is a regular request-response
import App from './App-stream.jsx'


createRoot(document.getElementById('root')).render(
     <App />
)
